import React, { useRef, useEffect } from "react";
import { Col, Form as bootstrapForm, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import IntlTelInput from "react-intl-tel-input";
import LanguageDropDown from "../Common/LanguageDropDown";

const UserContactInformation = (props) => {
  const { t } = useTranslation();
  // intl tel input handler
  const handlePhoneChange = (_status, phoneNumber, country) => {
    props.change({
      target: {
        name: "phone_number",
        value: phoneNumber,
      },
    });

    props.change({
      target: {
        name: "phone_number_country",
        value: country.iso2,
      },
    });
    // props.setCountryISO(country.iso2);
  };

  const handleFlagChange = (_data, t1, _t2) => {
    props.change({
      target: {
        name: "phone_number_country",
        value: t1.iso2,
      },
    });
    // props.setCountryISO(t1.iso2);
  };
  const intlTelInputRef = useRef();
  useEffect(() => {
    if (intlTelInputRef.current) {
      if (intlTelInputRef.current?.tel) {
        const intlInputParentDOM = intlTelInputRef.current?.tel?.parentElement;
        if (intlInputParentDOM) {
          const dialcodeDOM =
            intlInputParentDOM.firstElementChild.querySelector(
              ".selected-dial-code"
            );
          if (dialcodeDOM) {
            dialcodeDOM.classList.remove("selected-dial-code");
            dialcodeDOM.style.marginLeft = "5px";
          }
        }
      }
    }
    if (
      intlTelInputRef.current &&
      props.values.phone_number_country &&
      props.values.phone_number_country.length > 0
    ) {
      intlTelInputRef.current.setFlag(props.values.phone_number_country);
    }
  }, [intlTelInputRef, props.values]);
  return (
    <div>
      <div className="header">
        {t("Modules.User management (+ add new).Contact information")}
      </div>
      {!props.isEditForm && (
        <Row>
          <Col md={9}>
            <bootstrapForm.Group>
              <bootstrapForm.Label>
                {t("Modules.User management (+ add new).Email")}
                <span style={{ color: "red" }}>*</span>
              </bootstrapForm.Label>
              <bootstrapForm.Control
                type="email"
                name="email"
                isInvalid={props.touched.email && props.error?.email}
                value={
                  props.values?.email
                    ? props.values?.email.trimStart()
                    : props.values?.email
                }
                onChange={props.change}
                disabled={props.isedit}
              ></bootstrapForm.Control>
            </bootstrapForm.Group>
          </Col>
        </Row>
      )}
      <Row>
        <Col md={6}>
          <bootstrapForm.Group>
            <bootstrapForm.Label>
              {t("Modules.User management (+ add new).Address")}
              <span style={{ color: "red" }}>*</span>
            </bootstrapForm.Label>
            <bootstrapForm.Control
              type="text"
              name="contact_address_street"
              isInvalid={
                props.touched.contact_address_street &&
                props.error?.contact_address_street
              }
              value={
                props.values?.contact_address_street
                  ? props.values?.contact_address_street.trimStart()
                  : props.values?.contact_address_street
              }
              onChange={props.change}
            ></bootstrapForm.Control>
          </bootstrapForm.Group>
        </Col>
        <Col md={3}>
          <bootstrapForm.Group>
            <bootstrapForm.Label>
              {t("Modules.User management (+ add new).ZipCode")}
              <span style={{ color: "red" }}>*</span>
            </bootstrapForm.Label>
            <bootstrapForm.Control
              type="text"
              name="contact_address_zipcode"
              isInvalid={
                props.touched.contact_address_zipcode &&
                props.error?.contact_address_zipcode
              }
              value={
                props.values?.contact_address_zipcode
                  ? props.values?.contact_address_zipcode.trimStart()
                  : props.values?.contact_address_zipcode
              }
              onChange={props.change}
            ></bootstrapForm.Control>
          </bootstrapForm.Group>
        </Col>
      </Row>
      <Row></Row>
      <Row>
        <Col md={3}>
          <bootstrapForm.Group>
            <bootstrapForm.Label>
              {t("Modules.User management (+ add new).Country")}{" "}
              <span style={{ color: "red" }}>*</span>
            </bootstrapForm.Label>
            <LanguageDropDown
              val={props.country}
              touched={props.touched}
              errors={props.error}
              inpName={"contact_address_country_id"}
              updateDropdown={props.updateCountry}
              values={props.OldCountryVal}
            ></LanguageDropDown>
          </bootstrapForm.Group>
        </Col>
        <Col md={3}>
          {props.idCountry !== undefined && (
            <bootstrapForm.Group>
              <bootstrapForm.Label>
                {t("Modules.User management (+ add new).State/Province")}
              </bootstrapForm.Label>
              <LanguageDropDown
                val={props.states}
                touched={props.touched}
                errors={props.error}
                inpName={"contact_address_state_id"}
                updateDropdown={props.updateState}
                values={props.OldStateVal}
              ></LanguageDropDown>
            </bootstrapForm.Group>
          )}
        </Col>

        <Col md={3}>
          {props.idCountry !== undefined && (
            <bootstrapForm.Group>
              <bootstrapForm.Label>
                {t("Modules.User management (+ add new).City")}
                <span style={{ color: "red" }}>*</span>
              </bootstrapForm.Label>
              <bootstrapForm.Control
                type="text"
                name="contact_address_city"
                value={
                  props.values?.contact_address_city
                    ? props.values?.contact_address_city.trimStart()
                    : props.values?.contact_address_city
                }
                isInvalid={
                  props.touched.contact_address_city &&
                  props.error?.contact_address_city
                }
                onChange={props.change}
              ></bootstrapForm.Control>
            </bootstrapForm.Group>
          )}
        </Col>
      </Row>
      <Row>
        <Col md={9}>
          <bootstrapForm.Group>
            <bootstrapForm.Label>
              {t("Modules.User management (+ add new).Phone Number")}{" "}
              <span style={{ color: "red" }}>*</span>
            </bootstrapForm.Label>
            {/* <bootstrapForm.Control
                            type="text"
                            name="phone_number"
                            isInvalid={props.touched.phone_number && props.error?.phone_number}
                            value={props.values?.phone_number?props.values?.phone_number.trimStart():props.values?.phone_number}
                            onChange={props.change}
                        ></bootstrapForm.Control> */}
            <IntlTelInput
              containerClassName="intl-tel-input"
              inputClassName="form-control"
              input
              type="tel"
              value={
                props.values?.phone_number
                  ? props.values?.phone_number.trimStart()
                  : props.values?.phone_number
              }
              fieldName="phone_number"
              onSelectFlag={handleFlagChange}
              onPhoneNumberChange={handlePhoneChange}
              separateDialCode={true}
              ref={intlTelInputRef}
            />
          </bootstrapForm.Group>
        </Col>
      </Row>
    </div>
  );
};
export default UserContactInformation;
